// Zweck: Gemeinsame Lager-Kacheln und Buchungsschritte für App und lokale Simulation. Stand: 21.10.2026.
const hints = {
  issue: 'Mehrere Artikel aus dem Lager ausgeben',
  receipt: 'Geliefertes Material ins Lager aufnehmen',
  return: 'Übriges Material wieder ins Lager legen',
};
export function WarehouseIcon({
  kind,
}: {
  kind:
    | 'issue'
    | 'receipt'
    | 'return'
    | 'stock'
    | 'release'
    | 'history'
    | 'edit'
    | 'warning'
    | 'info'
    | 'home'
    | 'location';
}) {
  const paths = {
    info: 'M12 11v6m0-10v1M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z',
    home: 'm3 11 9-8 9 8M5 10v11h14V10M9 21v-7h6v7',
    location:
      'M19 9c0 5-7 12-7 12S5 14 5 9a7 7 0 1 1 14 0ZM15 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
    issue: 'M4 12h16m-6-6 6 6-6 6M4 5v14',
    receipt: 'M12 3v13m-5-5 5 5 5-5M4 17v4h16v-4',
    return: 'M9 5 3 11l6 6M3 11h11a6 6 0 0 1 6 6v3',
    release: 'M5 12l4 4L19 6',
    history: 'M3 11a9 9 0 1 1 3 8M3 4v7h7m2-4v6l4 2',
    edit: 'm15 4 5 5M4 20l5-1L21 7l-5-5L4 14v6Z',
    warning: 'm12 3 10 18H2L12 3Zm0 6v5m0 3v1',
    stock: 'm12 3 9 5-9 5-9-5 9-5Zm-9 5v9l9 5 9-5V8m-9 5v9',
  };
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[kind]} />
    </svg>
  );
}
export function WarehouseSteps({
  step,
  material = false,
  labels,
}: {
  step: number;
  material?: boolean;
  labels?: readonly string[];
}) {
  return (
    <ol className="wh-steps" aria-label="Fortschritt">
      {(
        labels ?? [
          'Zuordnung',
          material ? 'Materialliste' : 'Artikelliste',
          'Prüfen',
        ]
      ).map((title, index) => (
        <li key={title} aria-current={step === index + 1 ? 'step' : undefined}>
          {index + 1}. {title}
        </li>
      ))}
    </ol>
  );
}

export function WarehouseHomeActions({
  disabled,
  onStart,
  onStock,
  stockDisabled,
}: {
  disabled: boolean;
  onStart: (kind: 'issue' | 'receipt' | 'return') => void;
  onStock: () => void;
  stockDisabled?: boolean;
}) {
  const labels = {
    issue: 'Material ausgeben',
    receipt: 'Lieferung annehmen',
    return: 'Material zurücknehmen',
  };
  return (
    <div className="wh-start">
      {(['issue', 'receipt', 'return'] as const).map((kind) => (
        <button
          aria-label={labels[kind]}
          disabled={disabled}
          key={kind}
          onClick={() => onStart(kind)}
        >
          <WarehouseIcon kind={kind} />
          <span>
            <strong>{labels[kind]}</strong>
            <small>{hints[kind]}</small>
          </span>
        </button>
      ))}
      <button
        aria-label="Bestand"
        disabled={stockDisabled ?? disabled}
        onClick={onStock}
      >
        <WarehouseIcon kind="stock" />
        <span>
          <strong>Bestand</strong>
          <small>Artikel, Lagerort und verfügbare Menge finden</small>
        </span>
      </button>
    </div>
  );
}
